import type { Cell, CellStyle, ITableLayerProps } from '@/version-types';
import tablePresets from '../presets';

export const getCellStyle = (
    cell: Cell,
    tableLayerData: Pick<ITableLayerProps, 'allStyleId' | 'styles' | 'presetId'>,
): CellStyle => {
    const defaultStyle =
        tablePresets.find((p) => p.id === tableLayerData.presetId)?.getCellDefaultStyle?.(cell, tableLayerData) ??
        tableLayerData.styles[tableLayerData.allStyleId];
    const cellStyle = cell.styleIds.reduce<CellStyle>((res, styleId) => {
        return {
            ...res,
            ...tableLayerData.styles[styleId],
        };
    }, {});
    return {
        ...defaultStyle,
        ...cellStyle,
    };
};
